module.exports = __webpack_public_path__ + "static/media/equipo.e79e84d9.svg";